import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ListingsFacade } from '@app/shared/+state/listings';
import { ListingReview, LoadingState } from '@app/shared/interfaces';
import { Channel } from '@app/shared/models/channel';
import { HostInviteUser, InviteHostsService } from '@app/shared/services/invite-hosts/invite-hosts.service';
import { Observable } from 'rxjs';

@Component({
  standalone: false,
  templateUrl: './connect-invite-your-hosts.component.html',
  styleUrls: ['./connect-invite-your-hosts.component.scss'],
})
export class ConnectInviteYourHostsComponent implements OnInit {
  platform: Channel;
  platformText: {
    name: string;
    withArticle: string;
  };

  channelId: string;

  pageLoadingState$: Observable<LoadingState>;
  listingReviews$: Observable<ListingReview['listings']> | null;

  LoadingState = LoadingState;
  saving: boolean;

  invitees: HostInviteUser[] = [
    {
      name: '',
      email: '',
    },
  ];

  constructor(
    private listingsFacade: ListingsFacade,
    private readonly inviteHostsService: InviteHostsService,
    private readonly route: ActivatedRoute,
    private readonly router: Router
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.platform = params['platform'] ? params['platform'] : 'airbnb-official';
      this.channelId = this.route.snapshot.paramMap.get('channelId');
      switch (this.platform) {
        case 'homeaway':
          this.platformText = {
            name: 'Vrbo',
            withArticle: 'a Vrbo',
          };
          break;

        case 'airbnb-official':
        case 'airbnb':
          this.platformText = {
            name: 'Airbnb',
            withArticle: 'an Airbnb',
          };
          break;

        default:
          break;
      }

      this.listingReviews$ = this.listingsFacade.listingReviewsNeedingPrimaryHost$;
      this.pageLoadingState$ = this.listingsFacade.listingReviewsLoadingState$;
      this.listingsFacade.loadListingReviews(this.platform, this.channelId);
    });
  }

  goBack() {
    this.router.navigate([`/accounts/listings/${this.platform}/${this.channelId}`]);
  }

  continue() {
    this.saving = true;

    this.inviteHostsService.sendInvites(this.invitees, this.platform, this.channelId).subscribe(
      (res) => {
        if (res.success) {
          this.router.navigate(['/accounts/new/complete'], {
            queryParams: { platform: this.platform },
          });
        }
      },
      (error) => {}
    );
  }
}
